<template>
  <b-form-select
    v-model="selectedId"
    size="sm"
    :disabled="disabled"
    @change="onSelect"
  >
    <b-form-select-option :value="null">ไม่ใช้ส่วนลด</b-form-select-option>
    <b-form-select-option
      v-for="d in suggestions"
      :key="d.discountId"
      :value="d.discountId"
    >
      <template v-if="d.discountMethod === 1">
        {{ d.name }}
        <template v-if="d.discountType === 0">
          (ลดค่าหมอ {{ d.doctorDiscountValue }}% ของส่วนแบ่งหมอ
          / คลินิก {{ d.clinicDiscountValue }}% ของส่วนแบ่งคลินิก)
        </template>
        <template v-else>
          (ลดค่าหมอ {{ d.doctorDiscountValue }} บาท
          / คลินิก {{ d.clinicDiscountValue }} บาท)
        </template>
        = -{{ d.calculated.discountAmount }} บาท
      </template>
      <template v-else>
        {{ d.name }}
        ({{ d.discountType === 0 ? `-${d.discountValue}%` : `-${d.discountValue} บาท` }})
        = -{{ d.calculated.discountAmount }} บาท
      </template>
    </b-form-select-option>
  </b-form-select>
</template>

<script>
export default {
  name: "DiscountPicker",
  props: {
    suggestions: { type: Array, default: () => [] },
    value: { type: Number, default: null },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      selectedId: this.value,
    };
  },
  watch: {
    value(val) {
      this.selectedId = val;
    },
  },
  methods: {
    onSelect(discountId) {
      const selected = discountId
        ? this.suggestions.find(d => d.discountId === discountId)
        : null;
      this.$emit("input", discountId);
      this.$emit("selected", selected);
    },
  },
};
</script>
